module.exports = __webpack_public_path__ + "img/send-chat-active.e5275b80.svg";